import React, { useState, useEffect } from "react";
import useReduxState from "src/hooks/useReduxState";
import Common from "src/pages/Quote/Common";
import Constants from "src/support/Constants";
import Helper from "src/support/Helper";

const QuoteCustomerPartNumberOptions = (props) => {
  const { single_product } = props;
  const ItemNumber = single_product.ItemNumber
  const isCPNListExists = single_product.CustomerPartNumbers?.length > 0 ? true : false;
  const isManual = Common.isCpnIsManual(single_product, props.defaultValue);
  const [isTypeUpdate, setIsTypeUpdate] = useState(false);
  const cpnType = Common.setDefaultCpnType(isCPNListExists, props.isForEdit, isManual, isTypeUpdate)
  const [manuallyCpnValue, setManuallyCpnValue] = useState("");
  const [selectedCpnOption, setSelectedCpnOption] = useState(cpnType);
  const [isDisabled, setIsDisabled] = useReduxState(false, 'setIsDisabled');

  useEffect(() => {
    setSelectedCpnOption(cpnType)
    setManuallyCpnValue(isManual ? props.defaultValue : "")
  }, [props.defaultValue])

  const onApplyManualCpn = () => {
    setIsTypeUpdate(true);
    props.updationCompletedCallback(manuallyCpnValue);
  };

  const onSelectCPNType = async (type) => {
    setSelectedCpnOption(type);
    let _cpn = type === Constants.cpnTypes.MPN ? manuallyCpnValue ? manuallyCpnValue : "" : single_product.CustomerPartNumbers[0].CPN;
    props.updationCompletedCallback(_cpn);
  };

  const onManuallyCpnChange = (e) => {
    let mnpCPN = Helper.toUpperCase(e.target.value);
    setManuallyCpnValue(mnpCPN);
    props.updationCompletedCallback(mnpCPN);
  };

  const onSelectCPN = (val) => {
    props.updationCompletedCallback(val);
  }

  return (
    <>
      <div className="form-group">
        <label htmlFor="sel1" className="text-nowrap">
          <b>Customer Part Number</b>
        </label>

        {isCPNListExists && (
          <>
            <div className="cpn-manually-checkbox">
              <div className="form-check form-check-inline">
                <input className="form-check-input" type="radio"
                  name={"cpnOption-" + ItemNumber}
                  id="cpn" value="cpn"
                  onChange={async (e) => onSelectCPNType(e.target.value)}
                  checked={selectedCpnOption === Constants.cpnTypes.CPN ? true : false}
                />
                <label className="form-check-label" htmlFor="cpn"> Choose CPN </label>
              </div>
              <div className="form-check form-check-inline me-0">
                <input className="form-check-input" type="radio"
                  name={"cpnOption-" + ItemNumber}
                  id="mpn"
                  value="mpn"
                  onChange={async (e) => { setSelectedCpnOption(e.target.value); }}
                  onClick={onApplyManualCpn}
                  checked={selectedCpnOption === Constants.cpnTypes.MPN ? true : false}
                />
                <label className="form-check-label" htmlFor="mpn"> Manually Add </label>
              </div>
            </div>
          </>
        )}
        {selectedCpnOption === Constants.cpnTypes.CPN && (
          <>
            {single_product?.CustomerPartNumbers?.length > 1 &&
              <>
                <div className="selectbox">
                  <select
                    className="form-control form-control-xs"
                    onChange={async (e) => { onSelectCPN(e.target.value) }}
                    value={props.defaultValue}
                    id="Customer"
                  >
                    {single_product?.CustomerPartNumbers.map((v, i) => (
                      <React.Fragment key={i}>
                        <option value={v.CPN}>{v.CPN}</option>
                      </React.Fragment>
                    ))}
                  </select>
                </div>
              </>
            }
            {single_product?.CustomerPartNumbers?.length === 1 && (
              <div className="">
                <label>{single_product.CustomerPartNumbers[0].CPN}</label>
              </div>
            )}
          </>

        )}

        {(!isCPNListExists || (isCPNListExists && selectedCpnOption === Constants.cpnTypes.MPN)) && (
          <div className="cpn-manually-input ">
            <div className="bs5 d-flex align-items-center">
              <input
                className="form-control form-control-xs"
                type="text"
                placeholder="ex. 4353ES"
                maxLength={35}
                value={manuallyCpnValue}
                onMouseEnter={() => !isDisabled && setIsDisabled(true)}
                onMouseLeave={() => isDisabled && setIsDisabled(false)}
                onClick={() => setIsDisabled(true)}
                onChange={(e) => {
                  onManuallyCpnChange(e);
                }}
              />
            </div>
          </div>
        )}
      </div>
    </>

  );
};

export default QuoteCustomerPartNumberOptions;
